import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import format from 'utils/formatMoney'
import styles from 'modules/Finance/Wallets/subcomponents/Price/Price.module.scss'

const Price = ({ className = '', number = 0, currency = 'RUB' }) => (
  <span
    className={clsx(styles['price'], className)}
    dangerouslySetInnerHTML={{ __html: format(number, currency) }}
  />
)

export default Price

Price.propTypes = {
  className: PropTypes.string,
  number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  currency: PropTypes.string,
}
